import { Component, Input, OnInit } from "@angular/core";
declare const $: any;
@Component({
  selector: "app-image",
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.css"],
})
export class ImageComponent implements OnInit {
  @Input() public settings: any;
  public height: number;
  constructor() {}

  public ngOnInit() {}

  public ngAfterViewInit() {
    const id = this.settings.id;
    if (this.settings.cover) {
      this.height = $(".img-section-" + id).height($(window).innerHeight());
      $(".img-section-" + id).height(
        $(window).innerHeight() - $("nav:first-child").innerHeight()
      );
    }
  }
  public navigateToSection(el) {
    const elmnt = document.getElementById(el);
    elmnt.scrollIntoView();
  }
}
